export default () => ({
  locations: [],
  currentLocation: {},
  locationsCount: 0,
})
